<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v">For Alison.<br/>You put a spell on me.</a></p><a id="page_v">
</a><p class="image"><a id="page_v"><img alt="Image" src="images/dedi.jpg"/></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?7585360f